import { render } from "./tw-container.vue?vue&type=template&id=15f2336c"
import script from "./tw-container.vue?vue&type=script&lang=js"
export * from "./tw-container.vue?vue&type=script&lang=js"
script.render = render

export default script